import React from 'react';
import { Link, NavLink } from 'react-router-dom';

import Tag from 'antd/es/tag';

import ImageWithSkeleton from '@commonTuna/react/components/UI/ImageWithSkeleton/ImageWithSkeleton';
import { numberWithComma } from '@commonTuna/react/utils/NumberWithComma/NumberWithComma';

import { getLocationName } from '@app/utils/Utils';
import SpecialtyTag from '@app/components/Pages/Specialties/SpecialtyTag';
import { getClinicAvatar } from '@app/components/Pages/Clinics/Clinics';
import { Location } from '@app/objects/Location';
import Stars from '@app/components/UI/Stars/Stars';
import ShowPhone from '@app/components/UI/ShowPhone/ShowPhone';
import Rate from '@app/components/Pages/Doctor/Rate';

interface ClinicCardProps {
	location: Location;
}

const ClinicCard: React.FC<ClinicCardProps> = ({ location }) => {
	if (!location.nameEn || location.nameEn === ' ') {
		return null;
	}

	return <div className="clinic-card clearfix">
		{location.path
			? <Link to={`/clinics/${location.path}`} className="clinic-card__image">
				<ImageWithSkeleton
					src={getClinicAvatar(location)}
					alt="Clinic avatar"
				/>
			</Link>
			: <div className="clinic-card__image">
				<ImageWithSkeleton
					src={getClinicAvatar(location)}
					alt="Clinic avatar"
				/>
			</div>
		}
		<div className="clinic-card__body">
			<div>
				<Rate
					className="pull-right rate hide-mobile"
					averageReviewRate={location.averageReviewRate}
					totalReviewCount={location.totalReviewCount}
					starsClassName="mr10"
				/>
				{location.portalPathEn
					? <Link to={`/clinics/${location.portalPathEn}`} className="clinic-card__name">
						<h2>
							{getLocationName(location, false, false, true)}
						</h2>
					</Link>
					: <h2>
						{getLocationName(location, false, false, true)}
					</h2>
				}
			</div>
			<div className="clinic-card__tags">
				<Rate
					className="pull-right rate show-mobile"
					averageReviewRate={location.averageReviewRate}
					totalReviewCount={location.totalReviewCount}
					starsClassName="mr10"
				/>
				{location.specialties?.length > 0 && location.specialties.filter((item) => item)
					.map((item) => <SpecialtyTag
						key={`specialty${item.id}`}
						tagClassName="title__second"
						specialty={item}
					/>)}
				<div className="space" key="space" />
				{location.procedures?.length > 0 && location.procedures?.filter((item) => item)
					.map((item) =>
						(<span key={`procedure${item.id}`}>
							{item.path
								? <NavLink to={`/procedures/${item.path}`}>
									<Tag color="purple" key={item.id} className="title__second">
										{item.name}
									</Tag>
								</NavLink>
								: <Tag color="purple" key={item.id} className="title__second">
									{item.name}
								</Tag>
							}
						</span>))}
			</div>
			{location.portalShortDescription
				&& <div
					className="clinic-card__description mt10"
					dangerouslySetInnerHTML={{ __html: location.portalShortDescription }}
				/>
			}
			<div className="text-end">
				{location.showPhone && <ShowPhone phone={location.phone} location={location} />}
				{location.portalPathEn && <Link
					to={`/clinics/${location.portalPathEn}`}
					className="btn btn-sm btn-primary"
				>
					Send Inquiry
				</Link>}
			</div>
		</div>
	</div>;
};

export default ClinicCard;
